/* src/app/components/print-permission-policy/print-permission-policy.component.scss */
.content {
  padding: 30px;
}
h3,
h4,
p {
  text-align: center;
}
.text-center {
  text-align: center;
}
ion-button::part(native) {
  padding-inline: 50px;
}
.title1 {
  font-size: 32px;
}
p.title2 {
  font-size: 20px;
}
ion-item ion-label {
  white-space: unset !important;
  overflow: visible !important;
}
/*# sourceMappingURL=print-permission-policy.component-OWLSBBT3.css.map */
